import { Locale } from 'modules/i18n';

export const getPremiumButtonTranslation = {
  [Locale.en]: {
    label: 'Get Premium',
  },
};
